module.exports = __webpack_public_path__ + "img/prosper-mark.f044ca02.svg";